/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import type {
  AckResponse,
  AnalysedDataEndDatePayload,
  AnalysedDataEndDateResponse,
  CleanupDataPayload,
  CleanupTaxonomyPayload,
  DeleteUserDimensionMappingPayload,
  HTTPValidationError,
  ListTenantsRes,
  ProjectIdPayload,
  RefreshPayload,
  SetAnalysedDataEndDatePayload,
  UpsertUserDimensionMappingPayload,
  UserDimensionMappingsResponse,
} from '../model';

import { customFetch } from '../../fetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListTenantsUrl = () => {
  return `/api/v1/admin/list-tenants`;
};

/**
 * @summary List Tenants
 */
export const listTenants = async (options?: Parameters<typeof customFetch>[1]): Promise<ListTenantsRes> => {
  return customFetch<ListTenantsRes>(getListTenantsUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getListTenantsMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof listTenants>>, TError, void, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof listTenants>>, TError, void, TContext> => {
  const mutationKey = ['listTenants'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof listTenants>>, void> = () => {
    return listTenants(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListTenantsMutationResult = NonNullable<Awaited<ReturnType<typeof listTenants>>>;

export type ListTenantsMutationError = HTTPValidationError;

/**
 * @summary List Tenants
 */
export const useListTenants = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof listTenants>>, TError, void, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof listTenants>>, TError, void, TContext> => {
  return useMutation(getListTenantsMutationOptions(options));
};
export const getTablesRefreshUrl = () => {
  return `/api/v1/admin/tables-refresh`;
};

/**
 * @summary Tables Refresh
 */
export const tablesRefresh = async (
  refreshPayload: RefreshPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<AckResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AckResponse>(getTablesRefreshUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(refreshPayload),
  });
};

export const getTablesRefreshMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tablesRefresh>>,
    TError,
    TablesRefreshMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof tablesRefresh>>, TError, TablesRefreshMutationVariables, TContext> => {
  const mutationKey = ['tablesRefresh'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof tablesRefresh>>, TablesRefreshMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return tablesRefresh(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TablesRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof tablesRefresh>>>;
export type TablesRefreshMutationBody = RefreshPayload;
export type TablesRefreshMutationError = HTTPValidationError;
export type TablesRefreshMutationVariables = { data: RefreshPayload };

/**
 * @summary Tables Refresh
 */
export const useTablesRefresh = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tablesRefresh>>,
    TError,
    TablesRefreshMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof tablesRefresh>>, TError, TablesRefreshMutationVariables, TContext> => {
  return useMutation(getTablesRefreshMutationOptions(options));
};
export const getCleanupDataUrl = () => {
  return `/api/v1/admin/cleanup-data`;
};

/**
 * @summary Cleanup Data
 */
export const cleanupData = async (
  cleanupDataPayload: CleanupDataPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<AckResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AckResponse>(getCleanupDataUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cleanupDataPayload),
  });
};

export const getCleanupDataMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cleanupData>>,
    TError,
    CleanupDataMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof cleanupData>>, TError, CleanupDataMutationVariables, TContext> => {
  const mutationKey = ['cleanupData'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof cleanupData>>, CleanupDataMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return cleanupData(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CleanupDataMutationResult = NonNullable<Awaited<ReturnType<typeof cleanupData>>>;
export type CleanupDataMutationBody = CleanupDataPayload;
export type CleanupDataMutationError = HTTPValidationError;
export type CleanupDataMutationVariables = { data: CleanupDataPayload };

/**
 * @summary Cleanup Data
 */
export const useCleanupData = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cleanupData>>,
    TError,
    CleanupDataMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof cleanupData>>, TError, CleanupDataMutationVariables, TContext> => {
  return useMutation(getCleanupDataMutationOptions(options));
};
export const getCleanupTaxonomyUrl = () => {
  return `/api/v1/admin/cleanup-taxonomy`;
};

/**
 * @summary Cleanup Taxonomy
 */
export const cleanupTaxonomy = async (
  cleanupTaxonomyPayload: CleanupTaxonomyPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<AckResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AckResponse>(getCleanupTaxonomyUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cleanupTaxonomyPayload),
  });
};

export const getCleanupTaxonomyMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cleanupTaxonomy>>,
    TError,
    CleanupTaxonomyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cleanupTaxonomy>>,
  TError,
  CleanupTaxonomyMutationVariables,
  TContext
> => {
  const mutationKey = ['cleanupTaxonomy'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof cleanupTaxonomy>>, CleanupTaxonomyMutationVariables> = (
    props,
  ) => {
    const { data } = props ?? {};

    return cleanupTaxonomy(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CleanupTaxonomyMutationResult = NonNullable<Awaited<ReturnType<typeof cleanupTaxonomy>>>;
export type CleanupTaxonomyMutationBody = CleanupTaxonomyPayload;
export type CleanupTaxonomyMutationError = HTTPValidationError;
export type CleanupTaxonomyMutationVariables = { data: CleanupTaxonomyPayload };

/**
 * @summary Cleanup Taxonomy
 */
export const useCleanupTaxonomy = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cleanupTaxonomy>>,
    TError,
    CleanupTaxonomyMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cleanupTaxonomy>>,
  TError,
  CleanupTaxonomyMutationVariables,
  TContext
> => {
  return useMutation(getCleanupTaxonomyMutationOptions(options));
};
export const getResetCacheUrl = () => {
  return `/api/v1/admin/reset-cache`;
};

/**
 * @summary Reset Cache
 */
export const resetCache = async (options?: Parameters<typeof customFetch>[1]): Promise<AckResponse> => {
  return customFetch<AckResponse>(getResetCacheUrl(), {
    ...options,
    method: 'POST',
  });
};

export const getResetCacheMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof resetCache>>, TError, void, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<Awaited<ReturnType<typeof resetCache>>, TError, void, TContext> => {
  const mutationKey = ['resetCache'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetCache>>, void> = () => {
    return resetCache(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetCacheMutationResult = NonNullable<Awaited<ReturnType<typeof resetCache>>>;

export type ResetCacheMutationError = HTTPValidationError;

/**
 * @summary Reset Cache
 */
export const useResetCache = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof resetCache>>, TError, void, TContext>;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<Awaited<ReturnType<typeof resetCache>>, TError, void, TContext> => {
  return useMutation(getResetCacheMutationOptions(options));
};
export const getGetAnalysedDataEndDateUrl = () => {
  return `/api/v1/admin/analysed-data-end-date/get`;
};

/**
 * @summary Get Analysed Data End Date
 */
export const getAnalysedDataEndDate = async (
  analysedDataEndDatePayload: AnalysedDataEndDatePayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<AnalysedDataEndDateResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AnalysedDataEndDateResponse>(getGetAnalysedDataEndDateUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(analysedDataEndDatePayload),
  });
};

export const getGetAnalysedDataEndDateMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAnalysedDataEndDate>>,
    TError,
    GetAnalysedDataEndDateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAnalysedDataEndDate>>,
  TError,
  GetAnalysedDataEndDateMutationVariables,
  TContext
> => {
  const mutationKey = ['getAnalysedDataEndDate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAnalysedDataEndDate>>,
    GetAnalysedDataEndDateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return getAnalysedDataEndDate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAnalysedDataEndDateMutationResult = NonNullable<Awaited<ReturnType<typeof getAnalysedDataEndDate>>>;
export type GetAnalysedDataEndDateMutationBody = AnalysedDataEndDatePayload;
export type GetAnalysedDataEndDateMutationError = HTTPValidationError;
export type GetAnalysedDataEndDateMutationVariables = { data: AnalysedDataEndDatePayload };

/**
 * @summary Get Analysed Data End Date
 */
export const useGetAnalysedDataEndDate = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAnalysedDataEndDate>>,
    TError,
    GetAnalysedDataEndDateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAnalysedDataEndDate>>,
  TError,
  GetAnalysedDataEndDateMutationVariables,
  TContext
> => {
  return useMutation(getGetAnalysedDataEndDateMutationOptions(options));
};
export const getSetAnalysedDataEndDateUrl = () => {
  return `/api/v1/admin/analysed-data-end-date/set`;
};

/**
 * @summary Set Analysed Data End Date
 */
export const setAnalysedDataEndDate = async (
  setAnalysedDataEndDatePayload: SetAnalysedDataEndDatePayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<AnalysedDataEndDateResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<AnalysedDataEndDateResponse>(getSetAnalysedDataEndDateUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setAnalysedDataEndDatePayload),
  });
};

export const getSetAnalysedDataEndDateMutationOptions = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAnalysedDataEndDate>>,
    TError,
    SetAnalysedDataEndDateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setAnalysedDataEndDate>>,
  TError,
  SetAnalysedDataEndDateMutationVariables,
  TContext
> => {
  const mutationKey = ['setAnalysedDataEndDate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAnalysedDataEndDate>>,
    SetAnalysedDataEndDateMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return setAnalysedDataEndDate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetAnalysedDataEndDateMutationResult = NonNullable<Awaited<ReturnType<typeof setAnalysedDataEndDate>>>;
export type SetAnalysedDataEndDateMutationBody = SetAnalysedDataEndDatePayload;
export type SetAnalysedDataEndDateMutationError = HTTPValidationError;
export type SetAnalysedDataEndDateMutationVariables = { data: SetAnalysedDataEndDatePayload };

/**
 * @summary Set Analysed Data End Date
 */
export const useSetAnalysedDataEndDate = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setAnalysedDataEndDate>>,
    TError,
    SetAnalysedDataEndDateMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setAnalysedDataEndDate>>,
  TError,
  SetAnalysedDataEndDateMutationVariables,
  TContext
> => {
  return useMutation(getSetAnalysedDataEndDateMutationOptions(options));
};
export const getListUserDimensionMappingsUrl = () => {
  return `/api/v1/admin/user-dimension-mappings/list`;
};

/**
 * @summary List User Dimension Mappings
 */
export const listUserDimensionMappings = async (
  projectIdPayload: ProjectIdPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<UserDimensionMappingsResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<UserDimensionMappingsResponse>(getListUserDimensionMappingsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(projectIdPayload),
  });
};

export const getListUserDimensionMappingsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listUserDimensionMappings>>,
    TError,
    ListUserDimensionMappingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof listUserDimensionMappings>>,
  TError,
  ListUserDimensionMappingsMutationVariables,
  TContext
> => {
  const mutationKey = ['listUserDimensionMappings'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof listUserDimensionMappings>>,
    ListUserDimensionMappingsMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return listUserDimensionMappings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ListUserDimensionMappingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof listUserDimensionMappings>>
>;
export type ListUserDimensionMappingsMutationBody = ProjectIdPayload;
export type ListUserDimensionMappingsMutationError = HTTPValidationError;
export type ListUserDimensionMappingsMutationVariables = { data: ProjectIdPayload };

/**
 * @summary List User Dimension Mappings
 */
export const useListUserDimensionMappings = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof listUserDimensionMappings>>,
    TError,
    ListUserDimensionMappingsMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof listUserDimensionMappings>>,
  TError,
  ListUserDimensionMappingsMutationVariables,
  TContext
> => {
  return useMutation(getListUserDimensionMappingsMutationOptions(options));
};
export const getUpsertUserDimensionMappingUrl = () => {
  return `/api/v1/admin/user-dimension-mappings/upsert`;
};

/**
 * @summary Upsert User Dimension Mapping
 */
export const upsertUserDimensionMapping = async (
  upsertUserDimensionMappingPayload: UpsertUserDimensionMappingPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<UserDimensionMappingsResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<UserDimensionMappingsResponse>(getUpsertUserDimensionMappingUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(upsertUserDimensionMappingPayload),
  });
};

export const getUpsertUserDimensionMappingMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertUserDimensionMapping>>,
    TError,
    UpsertUserDimensionMappingMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertUserDimensionMapping>>,
  TError,
  UpsertUserDimensionMappingMutationVariables,
  TContext
> => {
  const mutationKey = ['upsertUserDimensionMapping'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertUserDimensionMapping>>,
    UpsertUserDimensionMappingMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return upsertUserDimensionMapping(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertUserDimensionMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertUserDimensionMapping>>
>;
export type UpsertUserDimensionMappingMutationBody = UpsertUserDimensionMappingPayload;
export type UpsertUserDimensionMappingMutationError = HTTPValidationError;
export type UpsertUserDimensionMappingMutationVariables = { data: UpsertUserDimensionMappingPayload };

/**
 * @summary Upsert User Dimension Mapping
 */
export const useUpsertUserDimensionMapping = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertUserDimensionMapping>>,
    TError,
    UpsertUserDimensionMappingMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upsertUserDimensionMapping>>,
  TError,
  UpsertUserDimensionMappingMutationVariables,
  TContext
> => {
  return useMutation(getUpsertUserDimensionMappingMutationOptions(options));
};
export const getDeleteUserDimensionMappingUrl = () => {
  return `/api/v1/admin/user-dimension-mappings/delete`;
};

/**
 * @summary Delete User Dimension Mapping
 */
export const deleteUserDimensionMapping = async (
  deleteUserDimensionMappingPayload: DeleteUserDimensionMappingPayload,
  options?: Parameters<typeof customFetch>[1],
): Promise<UserDimensionMappingsResponse> => {
  const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
  return customFetch<UserDimensionMappingsResponse>(getDeleteUserDimensionMappingUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deleteUserDimensionMappingPayload),
  });
};

export const getDeleteUserDimensionMappingMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserDimensionMapping>>,
    TError,
    DeleteUserDimensionMappingMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteUserDimensionMapping>>,
  TError,
  DeleteUserDimensionMappingMutationVariables,
  TContext
> => {
  const mutationKey = ['deleteUserDimensionMapping'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteUserDimensionMapping>>,
    DeleteUserDimensionMappingMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return deleteUserDimensionMapping(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteUserDimensionMappingMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteUserDimensionMapping>>
>;
export type DeleteUserDimensionMappingMutationBody = DeleteUserDimensionMappingPayload;
export type DeleteUserDimensionMappingMutationError = HTTPValidationError;
export type DeleteUserDimensionMappingMutationVariables = { data: DeleteUserDimensionMappingPayload };

/**
 * @summary Delete User Dimension Mapping
 */
export const useDeleteUserDimensionMapping = <TError = HTTPValidationError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteUserDimensionMapping>>,
    TError,
    DeleteUserDimensionMappingMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteUserDimensionMapping>>,
  TError,
  DeleteUserDimensionMappingMutationVariables,
  TContext
> => {
  return useMutation(getDeleteUserDimensionMappingMutationOptions(options));
};
